import { h, Component } from "preact";
import { Text } from "preact-i18n";
import logoWhite from "../img/logo-black.svg";
import feder from "../img/feder.png";

import projectA from "../img/projectoA.jpg";
import projectB from "../img/projectoB.jpg";
import projectC from "../img/projectoC.png";
class FooterBar extends Component {
  render() {
    return (
      <div class="uk-margin-top uk-margin-bottom">
        <div
          uk-grid=""
          class="uk-child-width-auto@m uk-flex-middle uk-grid"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div class="uk-first-column">
            <div class="uk-text-left@m uk-text-center">
              <img uk-svg src={logoWhite} width="150" />
            </div>
          </div>


          

          <div class="uk-text-right@m uk-text-right">
            <div
              uk-grid=""
              class="uk-child-width-auto uk-grid-small uk-flex-center uk-grid"
            >
              <div>
                <a
                  width="30"
                  href="https://www.linkedin.com/company/agroinsider"
                  uk-icon="icon: linkedin"
                  class="uk-icon-link uk-icon"
                />
              </div>
              <div>
                <a
                  width="30"
                  href="https://twitter.com/agroinsider"
                  uk-icon="icon: twitter"
                  class="uk-icon-link uk-icon"
                />
              </div>
              <div>
                <a
                  width="30"
                  href="https://www.facebook.com/Agroinsider/"
                  uk-icon="icon: facebook"
                  class="uk-icon-link uk-icon"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class Footer extends Component {
  render() {
    return (
      <div class="uk-section uk-section-secondary tm-section-secondary uk-section-large uk-padding-remove-bottom">
        <div class="uk-container uk-text-center">
          <h1 class="uk-h6 uk-margin-remove">
            <Text id="Footer.meetUs">Meet us offline</Text>
          </h1>
          <h2 class="uk-h1">
            <Text id="Footer.ourOffices">Our offices</Text>
          </h2>
          <div class="uk-child-width-expand@s" uk-grid>
            <div class="uk-grid-item-match">
              <h3 class="uk-h2 uk-margin-remove-bottom">
                <span class="uk-margin-small-right" uk-icon="location" />
                <Text id="Footer.hq">Europe - Headquarters</Text>
              </h3>
              <p class="uk-margin-remove-top">
                Rua Circular Norte, Edifício NERE Sala 12.10 7005 - 841 Évora
              </p>
            </div>
            <div class="uk-grid-item-match">
              <h3 class="uk-h2 uk-margin-remove-bottom">
                <span class="uk-margin-small-right" uk-icon="location" />
                <Text id="Footer.sub">Central America - Branch</Text>
              </h3>
              <p class="uk-margin-remove-top">
                Edificio World Trade Center Torre I, Piso 2 El Salvador
              </p>
            </div>
          </div>
          <hr class="uk-margin-remove-bottom uk-margin-xlarge-top" />
          <FooterBar />
        </div>
      </div>
    );
  }
}

export default Footer;
